import React from 'react';
import { useForm } from 'react-final-form';
import useKeybinding from '~/hooks/useKeybinding';

export type Props = {};

/**
 * A utility component that adds keyboard shortcuts to React Final Form forms.
 *
 * Currently implements:
 * - Enter key: Triggers form submission when pressed anywhere on the page
 *   except when focus is on form input fields.
 *
 * Form submission behavior:
 *   • When focus is outside form fields: This component handles submission
 *   • When focus is on form fields: React Final Form's built-in behavior takes over
 *   Note: Submit buttons must have type="submit" without onClick handlers for
 *   proper form submission behavior.
 *
 * This component must be used as a child of a Form component from react-final-form.
 *
 * @example
 * <Form onSubmit={handleSubmit}>
 *   <FormKeyBindings />
 *   {other form fields}
 * </Form>
 *
 * @returns {null} Renders nothing in the DOM
 */
const FormKeyBindings: React.FCC<Props> = () => {
  const form = useForm();

  useKeybinding({
    keys: 'enter',
    callback: form.submit,
  });

  return null;
};

export default FormKeyBindings;
